import angular from 'angular';
import otherDirectCostsActualsComponent from './other-direct-costs-actuals.component';

let otherDirectCostsActualsModule = angular.module('otherDirectCostsActuals', [])
  .component('otherDirectCostsActuals', otherDirectCostsActualsComponent);

export default otherDirectCostsActualsModule;



// WEBPACK FOOTER //
// ./client/pages/expenses/other-direct-costs-actuals/other-direct-costs-actuals.js